class Schedule {
  STORAGE_KEY = 'kenectTooltipSchedule';

  shouldShowTooltip() {
    if (!this.tooltipIsScheduled()) return true;

    return this.nextTooltipTime() < Date.now();
  }

  tooltipIsScheduled() {
    return !Number.isNaN(this.nextTooltipTime());
  }

  queueNextTooltipAppearance(timeFromNowInMs) {
    const nextAppearance = Date.now() + timeFromNowInMs;

    localStorage.setItem(this.STORAGE_KEY, nextAppearance);
  }

  nextTooltipTime() {
    return parseInt(localStorage.getItem(this.STORAGE_KEY));
  }
}

export default new Schedule();
